import en from './en/index.js';
export default () => en;
//# sourceMappingURL=index.js.map